<template>
  <div class="lecture">
    <b-loading :is-full-page="false" v-model="isLoading"></b-loading>
    <div class="coaching-container">
      <Coaching
        v-if="lecture"
        :topicIds="lecture.topicIds"
        :showClassRoll="showClassRoll && hasClass"
      >
        <template #additional-controls>
          <LectureControl
            v-if="lecture"
            :lecture="lecture"
            :showClassRoll="showClassRoll"
            :isPresentationMode="isPresentationMode"
            @start="startLecture"
            @complete="completeLecture"
            @toggle-class-roll="toggleClassRoll"
          />
        </template>

        <template #classroll>
          <ClassRoll v-if="hasClass" />
        </template>
      </Coaching>
    </div>

    <!-- ClassRoll Modal -->
    <b-modal
      :active="classRollModalOpen"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      @close="updateClassRollModalOpen(false)"
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Class Roll</p>
          <button
            type="button"
            class="delete"
            @click="updateClassRollModalOpen(false)"
          ></button>
        </header>
        <div style="height: 70vh; overflow-y: auto">
          <ClassRoll v-if="hasClass" />
          <div v-else>
            <p>No class selected</p>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Leaderboard Modal -->
    <b-modal
      :active="leaderboardModalOpen"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      @close="updateLeaderboardModalOpen(false)"
    >
      <div class="modal-card" style="max-height: 90vh">
        <header class="modal-card-head">
          <p class="modal-card-title">Class Leaderboard</p>
          <button
            type="button"
            class="delete"
            @click="updateLeaderboardModalOpen(false)"
          ></button>
        </header>
        <section
          class="modal-card-body"
          style="height: 70vh; overflow: hidden; padding: 0"
        >
          <ClassLeaderboard v-if="hasClass" />
          <div v-else>
            <p>No class selected</p>
          </div>
        </section>
      </div>
    </b-modal>
  </div>
</template>

<script>
import LectureRenderless from "./LectureRenderless";
import Coaching from "../coaching/Coaching.vue";
import LectureControl from "./LectureControl.vue";
import ClassRoll from "@/components/teacher/ClassRoll.vue";
import ClassLeaderboard from "@/components/teacher/ClassLeaderboard.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Lecture",

  components: {
    Coaching,
    LectureControl,
    ClassRoll,
    ClassLeaderboard,
  },

  mixins: [LectureRenderless],

  props: {
    lectureId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      showClassRoll: true,
      isPresentationMode: false,
    };
  },

  computed: {
    ...mapGetters({
      getShowMoveTable: "getShowMoveTable",
      currentClass: "getCurrentClass",
      classRollModalOpen: "getClassRollModalOpen",
      leaderboardModalOpen: "getLeaderboardModalOpen",
    }),

    hasClass() {
      return !!this.currentClass && !!this.currentClass.classId;
    },
  },

  methods: {
    ...mapActions({
      updateClassRollModalOpen: "updateClassRollModalOpen",
      setShowMoveTable: "setShowMoveTable",
      updateLeaderboardModalOpen: "updateLeaderboardModalOpen",
    }),

    toggleClassRoll() {
      this.showClassRoll = !this.showClassRoll;
      // hide move table
      this.setShowMoveTable(!this.showClassRoll);
      // this.updateClassRollModalOpen(!this.classRollModalOpen);
    },
  },

  async created() {
    this.showClassRoll = !this.getShowMoveTable;
    if (window.opener !== null) {
      this.isPresentationMode = true;
    }
  },
};
</script>

<style scoped>
.lecture {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.coaching-container {
  flex-grow: 1;
}

/* Add spacing between ExampleNavigator and LectureControl */
.scenario-navigator + .lecture-control {
  margin-left: 1rem;
}
</style>
